import { useQuery } from "@tanstack/react-query";
import { createElement, type ReactNode } from "react";
import type { PersonRef, Role } from "@audit-plan/shared";
import { api } from "./client";
import { Sensitive } from "../components/Sensitive";

export interface PersonDto extends PersonRef {
  role: Role;
  supplierId: string | null;
}

/** Tutte le persone (per select e per risolvere i nomi da id). */
export function usePeople() {
  const q = useQuery({ queryKey: ["people"], queryFn: () => api.get<PersonDto[]>("/people"), staleTime: 5 * 60_000 });
  const list = q.data ?? [];
  const byId = new Map(list.map((p) => [p.id, p]));
  return {
    ...q,
    list,
    name: (id?: string | null) => (id ? (byId.get(id)?.name ?? (id === "system" ? "Sistema" : "—")) : "—"),
    /**
     * Nome da mostrare: i referenti dei fornitori (ruolo supplier) escono marcati data-sensitive, le persone interne no.
     * Da usare dove la persona può essere un fornitore (assegnatario, chi ha caricato, chi ha fatto un passaggio).
     */
    show: (id?: string | null): ReactNode => {
      const p = id ? byId.get(id) : undefined;
      const n = id ? (p?.name ?? (id === "system" ? "Sistema" : "—")) : "—";
      return p?.role === "supplier" ? createElement(Sensitive, null, n) : n;
    },
    options: (roles: Role[]) => list.filter((p) => roles.includes(p.role)).map((p) => ({ value: p.id, label: p.name })),
  };
}
